/* eslint-disable @bigbinary/neeto/use-zustand-for-global-state-management */
import { createContext } from "react";

const EmailFormContext = createContext({
  showSendToField: false,
  showSendToAsRadio: false,
  showReplyToField: false,
  showCcField: false,
  showBccField: false,
});

export { EmailFormContext };
